function AdminAddEmployee() {
  return <></>;
}

export default AdminAddEmployee;
